import React, {useEffect} from 'react';
import {Form, Formik} from "formik";
import * as Yup from "yup";
import {Button, Form as FormLayout, ToggleButton} from "react-bootstrap";
import {formatFormTitle, FormikMultiFormSync} from "../../../../../../util/Helpers";
import riskProfileQues from "../../../../data/riskProfileQues";
import {useUpdateUserRiskProfileMutation} from "../../../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";

function RiskProfile(
    {
        dataKey,
        title,
        initialValues,
        isEditable
    }
) {
    const validationSchemaObject = {}
    const {userGroup, userId, riskProfile = {}} = initialValues

    const isFilled = Object.keys(riskProfile).length > 0

    const [
        updateRiskProfile, // This is the mutation trigger
        {
            isLoading: isUpdating,
            isSuccess: updatedSuccessfully,
        }, // This is the destructured mutation result
    ] = useUpdateUserRiskProfileMutation()

    /* Close Modal on KYC Approval */
    useEffect(() => {
        if (updatedSuccessfully) {
            cogoToast.success("Risk Profile Updated Successfully")
        }
    }, [updatedSuccessfully]);

    const submit = (values) => {
        const riskProfile = {riskQuestion: [], riskScore: 0};
        let points = 0;

        // Extract Risk Profile data and compute risk Score
        for (let i = 0; i < riskProfileQues.length; i++) {
            const {ques, answer} = riskProfileQues[i];
            const userAnswer = answer.find(item => item.opt === values[ques]);
            points += Number(userAnswer.point);
            riskProfile.riskQuestion.push({
                question: ques,
                answer: userAnswer.opt,
                point: userAnswer.point
            })

        }
        riskProfile.riskScore = Number((Math.round((points / 40) * 110) / 10).toFixed(1));

        values = {riskProfile}
        values.userGroup = userGroup
        values.userId = userId
        values.meta = initialValues
        updateRiskProfile(values)
    }

    const compiledInitialValues = {}
    if (isFilled) {
        for (const {question, answer} of riskProfile?.riskQuestion || []) {
            compiledInitialValues[question] = answer
        }
    } else {
        for (const {ques: question} of riskProfileQues) {
            validationSchemaObject[question] = Yup.string().required('Required')
            compiledInitialValues[question] = ""
        }
    }

    const validationSchema = Yup.object(validationSchemaObject)

    return (
        <div>
            <Formik
                validationSchema={validationSchema}
                initialValues={compiledInitialValues}
                validateOnMount={true}
                enableReinitialize={true}
            >
                {({isValid, values, setFieldValue, dirty}) =>
                    <Form>
                        <fieldset disabled={!isEditable}>
                            {formatFormTitle({title, isValid})}
                            {
                                isFilled && riskProfile.riskQuestion.map(({question, answer}, i) => (
                                    <div key={i}>
                                        <h6 className=" font-semibold dark:text-white text-muted text-sm mb-2">
                                            {question}
                                        </h6>
                                        <ToggleButton
                                            type="radio"
                                            variant={`outline-primary`}
                                            className={"mt-1 mb-10"}
                                        >
                                            {answer}
                                        </ToggleButton>
                                    </div>
                                ))
                            }
                            {
                                !isFilled && riskProfileQues.map(({ques: question, answer}, i) => (
                                    <div key={i}>
                                        <h6 className=" font-semibold dark:text-white text-muted text-sm mb-2">
                                            {question}
                                        </h6>
                                        <FormLayout.Row className="pt-1 pb-10">
                                            {answer.map(({opt: option, point}, i) => (
                                                <ToggleButton
                                                    key={i}
                                                    id={question}
                                                    type="radio"
                                                    name={question}
                                                    value={option}
                                                    variant={values[question] === option ? `outline-primary` : `outline-secondary`}
                                                    className={"mr-2"}
                                                    checked={values[question] === option}
                                                    onChange={(e) => setFieldValue(question, e.currentTarget.value)}
                                                >
                                                    {option}
                                                </ToggleButton>
                                            ))}
                                        </FormLayout.Row>
                                    </div>
                                ))
                            }
                            {
                                (dirty && isEditable) && <Button
                                    onClick={() => submit(values)}
                                    variant={"dark"}
                                    className={`w-100 position-sticky bottom-0 zindex-1 mt-2`}
                                    disabled={!isValid || isUpdating}
                                >
                                    Apply Changes
                                </Button>
                            }
                            <FormikMultiFormSync name={dataKey}/>
                        </fieldset>
                    </Form>
                }
            </Formik>
        </div>
    );
}

export default RiskProfile;